import { ACTION_SEARCH_MAP_BOUNDS } from 'utils/analytics/eventTypeConstantsAmplitude';
import { Button } from 'omakase';
import { CATEGORY_CITYWIDE_SEARCH } from 'utils/analytics/eventTypesConstants';
import { css } from '@emotion/react';
import { ga4SendEvent } from 'components/consent-restricted-scripts/GoogleAnalytics';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { useSearchHandlerContext } from 'components/search/SearchContext';
import ControlPanel from './ControlPanel';

interface Props {
  onClick(): void;
}

const hideShapeStyle = css`
  box-shadow: unset;
  background-color: unset;
`;

const buttonStyles = css`
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
`;

const Refresh: React.FunctionComponent<Props> = ({ onClick }) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const { analyticsSearchContext } = { ...useSearchHandlerContext() };

  const handleClick = () => {
    window.analytics.sendEvent(CATEGORY_CITYWIDE_SEARCH, 'Map bound search clicked');
    const data = {
      searchContext: analyticsSearchContext,
    };
    amplitudeSendEvent(ACTION_SEARCH_MAP_BOUNDS, data);
    ga4SendEvent('search_map_bounds', data);
    onClick();
  };

  return (
    <ControlPanel innerCss={hideShapeStyle}>
      <Button onClick={handleClick} variant="basic" size="medium" css={buttonStyles}>
        Search this area
      </Button>
    </ControlPanel>
  );
};

export default Refresh;
